export const colors = {
    primary: '#824ED2',
    titleColor: '#091E42',
    redColor: '#FC6C64',
    orangeColor: "#FFB300"
}